import aurasData from "./auras.js";
import itemsData from "./items.js";

export function profileReducer(state, action) {
  switch (action.type) {
    case "UPDATE_NAME":
      return {
        ...state,
        firstName: action.payload,
      };
    case "REPLACE_STATE":
      // Полностью заменяем состояние на новое
      return action.payload;

    case "UPDATE_DUNGEONS":
      return {
        ...state,

        openDungeons: action.payload,
      };
    case "UPDATE_SPINS":
      return {
        ...state,
        spins: action.payload,
      };
    case "UPDATE_AUTOSPIN":
      return {
        ...state,
        autospin: action.payload,
      };
    case "UPDATE_DUCKS":
      return {
        ...state,
        ducks: action.payload,
      };
    case "UPDATE_DEAL_DUCKS":
      return {
        ...state,
        dealDucks: action.payload,
      };
    case "UPDATE_DESCRIPTION":
      return {
        ...state,
        description: action.payload,
      };
    case "UPDATE_ITEMS":
      return {
        ...state,
        ItemsList: action.payload,
      };
    case "UPDATE_AURAS":
      return {
        ...state,
        AurasList: action.payload,
      };
    case "UPDATE_EQUIPMENT":
      return {
        ...state,
        ItemsList: action.payload.ItemsList,
        ring: action.payload.ring,
        glove: action.payload.glove,
        neck: action.payload.neck,
        head: action.payload.head,
      };

    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
}

export const getItemBySizeAndPower = (shopItem, size, power) => {
  // Перебираем все варианты (variants) и ищем совпадения по size и power
  for (const item of shopItem.variants) {
    if (item.size === size && item.power === power) {
      return item; // Возвращаем найденный элемент
    }
  }

  return null; // Если ничего не найдено, возвращаем null
};
export const formatNumber = (num) => {
  if (!num) return "0";

  const format = (value, suffix) =>
    Number.isInteger(value)
      ? `${value}${suffix}`
      : `${value.toFixed(1)}${suffix}`;

  return num >= 1e6
    ? format(num / 1e6, "m")
    : num >= 1e3
    ? format(num / 1e3, "k")
    : num.toString();
};

export const getRarity = (probability) => {
  let rarity;
  if (probability >= 5000000) {
    rarity = "Shining";
  } else if (probability >= 1000000) {
    rarity = "Legendary";
  } else if (probability >= 100000) {
    rarity = "Mythical";
  } else if (probability >= 10000) {
    rarity = "Rare";
  } else if (probability >= 1000) {
    rarity = "Uncommon";
  } else {
    rarity = "Common";
  }
  return rarity;
};
export const getAuraByName = async (value) => {
  for (var i = 0; i < aurasData.length; i++) {
    if (aurasData[i]["title"] === value) {
      const rarity = getRarity(aurasData[i].probability);
      const rarityColor = getRarityColor(rarity);
      const aura = {
        ...aurasData[i],
        rarity: rarity,
        rarityColor: rarityColor,
        type: "aura",
      };
      return aura;
    }
  }
  return null;
};

export const calculateAuraCost = (aura) => {
  let cost = Math.floor(
    calculateProbability(aura.probability, aura.auraLvl) * 0.09
  );
  if (cost <= 0) {
    cost += 1;
  }
  return cost;
};

export const getRarityColor = (rarity) => {
  let color;
  switch (rarity) {
    case "Shining":
      color = "#87F3B8";
      break;
    case "Legendary":
      color = "#E7BD25";
      break;
    case "Mythical":
      color = "#6640E7";
      break;
    case "Rare":
      color = "#3051DB";
      break;
    case "Uncommon":
      color = "#3CAD2B";
      break;
    case "Common":
      color = "#949494";
      break;
    default:
      color = "#949494";
      break;
  }
  return color;
};

export const getItemByName = async (value) => {
  for (var i = 0; i < itemsData.length; i++) {
    if (itemsData[i]["title"] === value) {
      return itemsData[i];
    }
  }
  return null;
};

export function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const calculateProbability = (probability, auraLvl) => {
  const newAuraProbability = probability * Math.pow(1.1, auraLvl || 0);
  return Math.round(newAuraProbability);
};

export function getContrastColor(hex) {
  // Убираем #, если он есть
  const sanitizedHex = hex.replace("#", "");

  // Парсим RGB
  const r = parseInt(sanitizedHex.substring(0, 2), 16);
  const g = parseInt(sanitizedHex.substring(2, 4), 16);
  const b = parseInt(sanitizedHex.substring(4, 6), 16);

  // Рассчитываем относительную яркость
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Если фон светлый, возвращаем черный цвет текста, иначе белый
  return luminance > 0.5 ? "#000000e1" : "#ffffffe1";
}

export const calculateStats = (activeItem) => {
  const hp = Math.ceil(
    activeItem.hp * (1 + 0.1 * activeItem.auraLvl) * activeItem.probability
  );
  const speed = activeItem.speed;
  const damage = Math.ceil(
    (activeItem.attack *
      activeItem.probability *
      (1 + 0.08 * activeItem.auraLvl)) /
      12
  );
  const bp = hp + damage * speed;
  return { hp, speed, damage, bp };
};

export const createQueue = () => {
  let queue = [];
  let isProcessing = false;

  const processQueue = async () => {
    if (isProcessing) return;
    isProcessing = true;

    while (queue.length > 0) {
      const { task, resolve, reject } = queue.shift();
      console.log("Processing task..."); // Логируем начало обработки задачи
      try {
        const result = await task();
        console.log("Task completed successfully:", result); // Успешное выполнение
        resolve(result);
      } catch (error) {
        console.error("Task failed:", error); // Ошибка выполнения
        reject(error);
      }
    }

    isProcessing = false;
    console.log("Queue processing finished."); // Очередь обработана
  };

  return {
    add(task) {
      console.log("Task added to queue."); // Логируем добавление задачи
      return new Promise((resolve, reject) => {
        queue.push({ task, resolve, reject });
        processQueue();
      });
    },
  };
};

export const enrichAndSortAuras = async (aurasList) => {
  if (!Array.isArray(aurasList)) return [];

  const cleanList = aurasList.filter(Boolean); // удаляем undefined/null заранее

  const enriched = await Promise.all(
    cleanList.map(async (aura) => {
      if (!aura?.title) return null;

      try {
        const auraInfo = await getAuraByName(aura.title);
        if (!auraInfo) return null;

        const cost = calculateAuraCost(auraInfo);
        return {
          ...aura,
          ...auraInfo,
          cost,
        };
      } catch (error) {
        console.warn(`Ошибка при получении ауры ${aura.title}:`, error);
        return null;
      }
    })
  );

  const filtered = enriched.filter(Boolean); // финальная чистка

  return sortAurasByProbability(filtered);
};

const sortAurasByProbability = (auras) => {
  return auras.sort(
    (a, b) =>
      calculateProbability(b.probability, b.auraLvl) -
      calculateProbability(a.probability, a.auraLvl)
  );
};
